import React from "react";
import { LanguageProvider } from "./src/context/LanguageContext";
import {
  initializeAnalytics,
  trackPageView,
} from "./src/utils/analytics";
import "./src/styles/global.css";

export function wrapRootElement({ element }) {
  return <LanguageProvider>{element}</LanguageProvider>;
}

export function onClientEntry() {
  initializeAnalytics();
}

export function onRouteUpdate() {
  trackPageView();
}
